/*
Documentation

this component renders the connect widget with MX

*/

import { useState, useCallback, useEffect } from "react";
import { withTranslation } from 'react-i18next';

import { Card, CardBody, Progress, Col, Container, Row } from "reactstrap";

import { toggleAlertBS } from 'store/functions/system/system';
import { setUrlParameter, removeUrlParameters } from 'utils/urls';

import _integrations from '_functions/integrations';
import _documents from '_functions/documents';

import Dots from 'components/markup/loading/Dots'


const MXVerifyExtended = ({
    foundContact, 
    foundCompany, 
    setView, 
    mxMemberToVerify, 
    redirectAfterVerify, 
    mxOpenConnect,
    t
}) => {

    const [progress, setProgress] = useState(0);

    const runProgress = useCallback((newProgress) => {
        if(newProgress === 100) return;
        const p = newProgress + 6 > 100 ? Math.floor(Math.random() * 10) : newProgress + 6
        setProgress(p);
        setTimeout(() => {
            runProgress(p)
        }, 1000)
    }, [])

    const runVerifyExtended = useCallback(async() => {
        runProgress(0)

        removeUrlParameters();

        const member = await await _integrations.mx.members.read({
            contact_id: foundContact._id, 
            company_id: foundCompany._id, 
            access_code: foundContact.access_code, 
            member_id: mxMemberToVerify
        })

        if(member.data && member.data.connection_status !== 'CONNECTED') {
            setUrlParameter('extended', mxMemberToVerify)
            setView('MXUpdateConnection');
            return;
        }

        const verified = await _integrations.mx.members.extend({
            contact_id: foundContact._id, 
            company_id: foundCompany._id, 
            access_code: foundContact.access_code, 
            member_id: mxMemberToVerify
        })

        if(!verified.data) {
            toggleAlertBS(true, `Account verification failed, please try again.`)
            return setView(redirectAfterVerify ? redirectAfterVerify : 'MXConnect')
        }
        if(verified.data && verified.data.needMFA) {
            setProgress(null);
            mxOpenConnect(mxMemberToVerify);
        } else {
            _documents.connectedMX({
                contact: foundContact._id, 
                company: foundCompany._id, 
                access_code: foundContact.access_code, 
                member_guid: mxMemberToVerify, 
            })
            setView(redirectAfterVerify ? redirectAfterVerify : 'MXConnect');
        }

    }, [foundCompany._id, foundContact._id, foundContact.access_code, mxMemberToVerify, mxOpenConnect, setView, runProgress, redirectAfterVerify])

    useEffect(() => {
        if(mxMemberToVerify) {
            runVerifyExtended()
        }
    }, [runVerifyExtended, mxMemberToVerify])

    return (

        <Container className="mt--9 pb-5">
            <Row className="justify-content-center">
                <Col lg="5" md="7">
                    <Card>
                        <CardBody>
                            {progress !== null ? (
                                <div className="progress-wrapper pt-3">
                                    <div className="progress-sucess">
                                        <div className="progress-label" style={{display: 'inline'}}>
                                            <span className="text-sucess" style={{position: 'relative', top: 13,}}>Progress</span>
                                        </div>
                                        <div className="progress-percentage">
                                        <span style={{position: 'relative', top: -3}}>{progress}%</span>
                                        </div>
                                    </div>
                                    <Progress max="100" value={progress} color="sucess" />
                                </div>
                            ) : null}
                            <h4 className="text-center">
                                {t(`MXVerifyExtended: Verifying Transactions`)}
                                <Dots />
                            </h4>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>

    )
}

export default withTranslation()(MXVerifyExtended);

